// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Dw-W","paramInput":"JobSimulator_paramInput__1GHs1","input":"JobSimulator_input__j3URZ"};